import { createContext, useContext } from 'react';
import type { PublicConfig } from '@medicail/shared';

export const ConfigContext = createContext<PublicConfig | null>(null);

export function useConfig(): PublicConfig {
  const cfg = useContext(ConfigContext);
  if (!cfg) throw new Error('useConfig must be used inside <ConfigProvider>');
  return cfg;
}

export async function fetchPublicConfig(): Promise<PublicConfig> {
  const res = await fetch('/api/config', { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error(`Could not load configuration (${res.status})`);
  return (await res.json()) as PublicConfig;
}
